import type {
  APIIntervals,
  APIOrderings,
  APIPromptTypeId,
  ItemType,
} from '../types/api'
import type { List } from '../types/list'
import type { PromptMinified, TopicModeData } from '../types/prompt'
import type { PROMPT_TYPES } from '../utils/constants'
import type { Elemental, ElementalTypeEnum } from '../types/elemental'
import type { GetUserPromptMode } from './users'
import { APIFetch, filterResponse } from '.'

export interface GetFeedItemsQuery {
  page?: number
  topic_id?: number | string
  size?: number
  order_dir?: 'asc' | 'desc'
  order_by?: APIOrderings
  interval?: APIIntervals
  is_premium?: boolean
  is_featured?: boolean | 'all'
  search?: string
  type_ids?: PROMPT_TYPES[]
  enterprise_id?: number
  item_type?: ItemType
  elemental_type_id?: ElementalTypeEnum
  elemental_type_ids?: ElementalTypeEnum[]
}
export const getHomeFeed = async (
  queries?: GetFeedItemsQuery,
): Promise<null | (List | PromptMinified)[]> => {
  let url = '/home-list'

  if (queries)
    url = useParseQuery(url, queries)

  return filterResponse(
    await APIFetch(url, {
      method: 'GET',
    }),
  )
}

export const getElementalHomeFeed = async (
  queries?: GetFeedItemsQuery,
): Promise<null | (List | Elemental)[]> => {
  let url = '/home-list'

  if (queries)
    url = useParseQuery(url, queries)

  return filterResponse(
    await APIFetch(url, {
      method: 'GET',
    }),
  )
}

interface GetProfileFeedQuery extends GetFeedItemsQuery {
  mode: GetUserPromptMode
  enterprise_id?: number
  type_ids?: APIPromptTypeId[]
}
export const getProfileFeed = async (
  userId: string,
  queries?: GetProfileFeedQuery,
): Promise<null | List[]> => {
  let url = `/profile-list/${userId}`

  if (queries)
    url = useParseQuery(url, queries)

  return filterResponse(
    await APIFetch(url, {
      method: 'GET',
    }),
  )
}

interface GetTopicFeedQuery extends GetFeedItemsQuery {
  topic_mode?: boolean
}
export const getTopicFeed = async (
  queries?: GetTopicFeedQuery,
): Promise<null | TopicModeData[]> => {
  let url = '/home-list'

  if (queries)
    url = useParseQuery(url, queries)

  return filterResponse(
    await APIFetch(url, {
      method: 'GET',
    }),
  )
}
